import { FormHelpers } from "@pharmupp/p3-front-commons"
import { formatISO } from "date-fns"
import type { FormValues } from "../UserForm/UserForm.component"
import type { ApiUserModel } from "../models"

export const formToServer = ({
  isUpdate,
  isConnectedUser,
  isReadOnly,
  isPrimary,
  isUpdateUserInformation,
  ...data
}: FormValues): ApiUserModel => {
  const { type, teamFunction } = data
  const isExtern = type === "EXTERN"
  const isTeam = type === "TEAM"
  const isOtherTeamFunction = teamFunction === "OTHER"

  return {
    ...FormHelpers.convertObjectValues(data, "", null),
    function: isTeam && isOtherTeamFunction ? data.function : null,
    teamFunction: isTeam ? data.teamFunction : null,
    externSpecification: isExtern ? data.externSpecification : null,
    unactivateDate:
      data.programmedUnactivate && data.unactivateDate
        ? formatISO(new Date(data.unactivateDate), { representation: "date" })
        : null,
    birthDate: data.birthDate
      ? formatISO(new Date(data.birthDate), { representation: "date" })
      : null,
  }
}

export const serverToForm = (formValues: ApiUserModel): FormValues => ({
  ...formValues,
  isUpdate: true,
})
